/**
 * Controller Class for VdAvatarMulti
 */
export default class VdAvatarMultiController {
  constructor($attrs) {
    'ngInject'

    this._$attrs = $attrs

    /**
     * The maximum number of remaining entities that can be represented in the remaining "count" tile. For example
     * given that we show 2 entities, if there are 101 items we can show "+99", anything more and we show ">99".
     *
     * @property remainderLimit
     * @type {Number}
     */
    this.remainderLimit = 101
  }

  $postLink() {
    this._$attrs.$addClass('vd-avatar-multi')
  }
}
